import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid
} from "@mui/material";
import { useEffect, useState } from "react";
import { sistema } from "../../../../model/Sistema";
import { CheckCircle, DoneAll, ExpandMore as ExpandMoreIcon, PublishedWithChanges, RemoveDone, Search } from "@mui/icons-material";
import moment from "moment";

const Confirmacion = ({open, onClose, onConfirm, reservas}) => {

  const unique = arr => {
    const seenIds = new Map();
    return arr.filter(obj => {
      if (seenIds.has(obj.id)) {
        return false; // Skip if ID is already seen
      }
      seenIds.set(obj.id, true); // Mark ID as seen
      return true; // Keep the object
    });
  }

  const tipos = Array.from(new Set(reservas?.map(item => item.subtipo)));
  const sectores = Array.from(new Set(reservas?.map(item => item.sector)));
  const fechas = Array.from(new Set(reservas?.map(item => item.fecha)));
  const puestos = Array.from(new Set(reservas?.filter(item => item.reserva_tipo === 'HOTDESK')));
  const salas = Array.from(new Set(reservas?.filter(item => (item.reserva_tipo !== 'HOTDESK') && (item.reserva_tipo !== 'OFICINA') ? item : null)));

  const textoDeTurno = (turno) => {
    switch (turno) {
      case 'AFTERNOON':
        return 'TARDE';
        break;
      case 'MORNING':
        return 'MAÑANA';
        break;
      case 'DOBLE':
        return 'DOBLE';
        break;
      default:
        return 'N/A';
        break;
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirmar cancelaciones</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle1" gutterBottom>
          {'Se procederá a cancelar:'}
        </Typography>
        <Typography gutterBottom>
          {(puestos.length > 0) && puestos.length + ' puesto' + (puestos.length > 1 ? 's' : '')}
          {(puestos.length > 0) && (salas.length > 0) && ' y '}
          {(salas.length > 0) && salas.length + ' sala' + (salas.length > 1 ? 's' : '')}
        </Typography>
        <Divider sx={{ my: 2 }} />
          <Accordion key={'reservas'}>
            <AccordionSummary expandIcon={<ExpandMoreIcon /> }>
              <Typography variant="subtitle" gutterBottom>
                {'Detalle de ' + reservas.length + ' reserva' + (reservas.length > 1 ? 's' : '')}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
            <List dense>
              {reservas.sort((a,b) => {return a.sector ?? '' > b.sector ?? ''}).map((reserva, index) => (
                <ListItem key={reserva.id}>
                  <Grid container>
                    <Grid sm={1} alignItems='center'><Typography>{(index + 1) + '.'}</Typography></Grid>
                    <Grid sm={4}>
                      <ListItemText sx={{ margin: 0 }}
                        primary={reserva.reserva_tipo + ' ' + moment(reserva.fecha).format('L ddd')}
                        secondary={reserva.espacio.nombre}
                        />
                    </Grid>
                    <Grid sm={7}>
                      {!!reserva.mesa && <ListItemText sx={{ margin: 0, color: reserva.usuarioAsignado?.nombre == 'diaDePrueba' ? 'salmon' : 'auto' }}
                        primary={reserva.sector + ' - ' + reserva.mesa + ' - P' + reserva.puesto + ' ' + textoDeTurno(reserva.turno)}
                        secondary={reserva.usuarioAsignado?.descripcion ?? 'Sin asignar'}
                        />}
                      {!!reserva.sala && <ListItemText sx={{ margin: 0 }}
                        primary={reserva.sala}
                        secondary={reserva.usuario?.descripcion ?? ''}
                        />}
                    </Grid>
                  </Grid>
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Volver</Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Confirmacion;
